import { FlxCommonsModule } from '@questrade/flx-commons';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { OnlineDemoModalPage } from './online-demo-modal';

@NgModule({
  declarations: [
    OnlineDemoModalPage,
  ],
  imports: [
    IonicPageModule.forChild(OnlineDemoModalPage),
    FlxCommonsModule
  ],
})
export class OnlineDemoModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/online-demo-modal/online-demo-modal.module.ts